import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { Observable, retry, throwError, timer } from "rxjs";

const RETRYABLE_STATUS = new Set([429, 500, 502, 503, 504]);
const MAX_RETRIES = 3;
const BASE_DELAY_MS = 300;

function isRetryable(error: HttpErrorResponse): boolean {
  return RETRYABLE_STATUS.has(error.status);
}

/**
 * Retries transient failures (503 Lambda throttling, 429, 5xx) with
 * exponential backoff — but ONLY for safe/idempotent methods. Retrying a
 * POST/PATCH after a 5xx can double-create a customer/estimate/payment when
 * the server actually processed the write.
 */
export function retryInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const retryable = req.method === "GET" || req.method === "HEAD";
  if (!retryable) return next(req);
  return next(req).pipe(
    retry({
      count: MAX_RETRIES,
      delay: (error, retryCount) => {
        if (!(error instanceof HttpErrorResponse) || !isRetryable(error)) {
          return throwError(() => error);
        }
        return timer(BASE_DELAY_MS * Math.pow(2, retryCount - 1));
      },
      resetOnSuccess: true,
    }),
  );
}
